import jwt_decode from "jwt-decode";

const APOLLO_MOBILE_TOKEN = "apollo-token-mobile";

export function setMobileToken(token) {
  if (typeof localStorage !== "undefined" && token) {
    localStorage.setItem(APOLLO_MOBILE_TOKEN, token);
  }
}

export function getMobileToken() {
  if (typeof localStorage !== "undefined") {
    const localToken = localStorage.getItem(APOLLO_MOBILE_TOKEN);
    if (localToken && !isTokenExpired(localToken)) {
      return localToken;
    } else if (localToken && isTokenExpired(localToken)) {
      clearMobileToken();
    }
  }
  return null;
}

export function clearMobileToken() {
  if (typeof localStorage !== "undefined") {
    localStorage.removeItem(APOLLO_MOBILE_TOKEN);
  }
}

export function isTokenExpired(token) {
  if (token) {
    try {
      const dateInSec = Date.now() / 1000;
      const tokenExpiration = jwt_decode(token)["exp"];
      if (tokenExpiration > dateInSec) return false;
    } catch (error) {
      return true;
    }
  }
  return true;
}

export function getQRTokenFromUrl() {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get("qrToken");
}
